<div class="bosysreview">
    <div class="bosysreviewwrapper">
        <img src="../../../../assets/tvg/holidaycheck.svg" class="bosysreviewimg" alt="holidaycheck">
        <div class="bosysreviewglbwrapper">
            <div class="bosysreviewglbitem">
                <span> {{review().HC_Gesamt}} %</span>
                <span>Gesamtbewertung</span>
            </div>
            <div class="bosysreviewglbitem">
                <span>{{review().HC_Weiter}} %</span>
                <span>Weiterempfehlung</span>
            </div>
        </div>
        @if(hotel()?.length > 0) {
        <div class="bwrttop">
            <span>Hotel allgemein</span>
            <div class="starsreviewwrpapper">
                <div class="starsreviewicon">
                    @for (bw of hotel(); track $index) {
                    <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                    }
                </div>
                <div class="starsreviewnummber">
                    {{review().HC_Hotel * 6 / 100 | number :'1.1-1'}}
                </div>
            </div>
        </div>
        }
        @if(room()?.length > 0) {
        <div class="bwrttop">
            <span>Zimmer</span>
            <div class="starsreviewwrpapper">
                <div class="starsreviewicon">
                    @for (bw of room(); track $index) {
                    <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                    }
                </div>
                <div class="starsreviewnummber">
                    {{review().HC_Zimmer * 6 / 100 | number :'1.1-1'}}
                </div>
            </div>
        </div>
        }
        @if(service()?.length > 0) {
        <div class="bwrttop">
            <span>Service</span>
            <div class="starsreviewwrpapper">
                <div class="starsreviewicon">
                    @for (bw of service(); track $index) {
                    <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                    }
                </div>
                <div class="starsreviewnummber">
                    {{review().HC_Service * 6 / 100 | number :'1.1-1'}}
                </div>
            </div>
        </div>
        }
        @if(location()?.length > 0) {
        <div class="bwrttop">
            <span>Lage</span>
            <div class="starsreviewwrpapper">
                <div class="starsreviewicon">
                    @for (bw of location(); track $index) {
                    <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                    }
                </div>
                <div class="starsreviewnummber">
                    {{review().HC_Lage * 6 / 100 | number :'1.1-1'}}
                </div>
            </div>
        </div>
        }
        @if(food()?.length > 0) {
        <div class="bwrttop">
            <span>Gastronomie</span>
            <div class="starsreviewwrpapper">
                <div class="starsreviewicon">
                    @for (bw of food(); track $index) {
                    <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                    }
                </div>
                <div class="starsreviewnummber">
                    {{review().HC_Gastro * 6 / 100 | number :'1.1-1'}}
                </div>
            </div>
        </div>
        }
        @if(sport()?.length > 0) {
        <div class="bwrttop">
            <span>Sport & Unterhaltung</span>
            <div class="starsreviewwrpapper">
                <div class="starsreviewicon">
                    @for (bw of sport(); track $index) {
                    <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                    }
                </div>
                <div class="starsreviewnummber">
                    {{review().HC_Sport * 6 / 100 | number :'1.1-1'}}
                </div>
            </div>
        </div>
        }

        <div class="bosyscopyright">
            © {{year()}} HolidayCheck
        </div>

    </div>
</div>